export default {
  applyToVersions: "<1.30.0",
  type: "before",
  name: "old before",
  migrate(data, { rootState }) {
    // transfer old question setting to question module
    if (data.question == null && data.project != null) {
      data.question = {};
      data.question.text = data.project.question;
    }

    // migration: selected template
    if (data.template && data.template.activeTemplate === "default") {
      data.templates = {};
      data.templates.activeTemplate = 0;
    }

    // migration: <1.26.3 - convert impulses to JSON string
    if (data.impulses && typeof data.impulses.items !== "string") {
      data.impulses.items = JSON.stringify(data.impulses.items);
      delete data.impulses.type;
      delete data.impulses.itemStructure;
    }

    // migration: <1.27.2 - remove orphaned followingIncidents
    if (data.measures && data.incidents) {
      const incidentIds = Object.keys(data.incidents.items);
      for (const measure of Object.values(data.measures.items)) {
        for (const followingIncidentId in measure.followingIncidents) {
          const fIncident = measure.followingIncidents[followingIncidentId];
          // remove the following incident if it does not exist anymore
          if (!incidentIds.includes(`${fIncident.id}`)) {
            delete measure.followingIncidents[followingIncidentId];
          }
        }
      }
    }

    // migration: <1.28.1 - remove orphaned followingIncidents in incidents
    if (data.incidents) {
      const incidentIds = Object.keys(data.incidents.items);
      for (const incident of Object.values(data.incidents.items)) {
        for (const followingIncidentId in incident.followingIncidents) {
          const fIncident = incident.followingIncidents[followingIncidentId];
          // remove the following incident if it does not exist anymore
          if (!incidentIds.includes(`${fIncident.id}`)) {
            delete incident.followingIncidents[followingIncidentId];
          }
        }
      }
    }

    // migration: (1.28.0) transfer images to seperate module
    if (!data.images) {
      // create images module in data
      data.images = JSON.parse(JSON.stringify(rootState.images));
      let imageCount = 0;

      if (data.elements) {
        // transfer images to new images store
        for (const elementId in data.elements.items) {
          const element = data.elements.items[elementId];
          if (element.imageData != null) {
            data.images.items[imageCount] = {
              type: "image",
              id: imageCount,
              data: element.imageData,
              aspectRatio: 1 / element.imageHeight
            };
            element.imageData = undefined;
            element.imageId = imageCount;
            imageCount++;
          }
        }

        // save the new image count
        data.images.count = imageCount;
      }

      // migration (1.28.0) transfer background image to image module
      if (data.templates) {
        if (data.templates.backgroundImage.data != null) {
          data.images.items[imageCount] = {
            id: imageCount,
            data: data.templates.backgroundImage.data
          };
          data.templates.backgroundImage.data = undefined;
          data.templates.backgroundImage.id = imageCount;

          imageCount++;

          // save the new image count
          data.images.count = imageCount;
        }
      }
    }

    if (data.stakeholders) {
      for (const stakeholder of Object.values(data.stakeholders.items)) {
        // migration 2019-04-29: move stakeholder documentation to description
        if (stakeholder.docs && stakeholder.docs.description) {
          stakeholder.description = stakeholder.docs.description;
          delete stakeholder.docs.description;
        }
      }
    }

    // Ensure that all objectstores have an order array
    for (const storeName in data) {
      const store = data[storeName];
      if (store && store.type == "objectstore") {
        if (!("order" in store)) {
          store.order = Object.keys(store.items).map(Number);
        }
      }
    }

    return data;
  }
};
